import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'h-4 w-4 border-2',
    medium: 'h-8 w-8 border-3',
    large: 'h-12 w-12 border-4'
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.medium;

  return (
    <div className={`inline-block ${spinnerSize} animate-spin rounded-full border-solid border-navy-600 border-r-transparent dark:border-navy-400 dark:border-r-transparent align-[-0.125em] ${className}`} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
};

// Simple inline spinner optimized for buttons and inline use
export const InlineSpinner = ({ className = '' }) => (
  <svg className={`animate-spin -ml-1 mr-2 h-4 w-4 ${className}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>
);

export default LoadingSpinner; 